module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inviteTextHeader":"Send the candidates a link to the video interview in any convenient way (job site, messenger, etc.)."}}')
  delete Component.options._Ctor
}
